export default "__VITE_ASSET__a1c6bfeb__"